"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["for"];
const _hoisted_2 = {
    key: 0,
    class: "label-text"
};
const _hoisted_3 = { class: "relative w-full flex flex-row items-center" };
const _hoisted_4 = {
    key: 0,
    class: "absolute w-10 flex items-center justify-center"
};
const _hoisted_5 = ["id", "type", "name", "placeholder", "autofocus", "required", "value", "disabled", "readonly", "maxlength", "max", "pattern", "autocomplete", "step"];
const _hoisted_6 = {
    key: 1,
    class: "error-message"
};
const vue_3 = require("vue");
const randomString_1 = __importDefault(require("../../common/utils/randomString"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ShopInput',
    props: {
        type: {
            type: String,
            default: "text",
        },
        // eslint-disable-next-line vue/require-default-prop
        name: String,
        placeholder: {
            type: String,
            required: false,
            default: "",
        },
        label: {
            type: String,
            required: false,
            default: "",
        },
        autofocus: Boolean,
        required: Boolean,
        // eslint-disable-next-line vue/require-default-prop
        pattern: String,
        showValidity: {
            type: Boolean,
            default: false,
        },
        valid: {
            type: Boolean,
            default: true,
            required: false,
        },
        invalidMessage: {
            type: String,
            required: false,
            default: "",
        },
        // eslint-disable-next-line vue/require-default-prop
        icon: {
            type: String,
            required: false,
        },
        modelValue: {
            type: [String, Number, () => null],
            default: null,
        },
        disableFocusRing: {
            type: Boolean,
            default: false,
        },
        border: {
            type: Boolean,
            default: false,
        },
        disabled: Boolean,
        readonly: Boolean,
        // eslint-disable-next-line vue/require-default-prop
        maxLength: {
            type: Number,
            required: false,
        },
        // eslint-disable-next-line vue/require-default-prop
        max: {
            type: [Number, String],
            required: false,
        },
        autocomplete: {
            type: Boolean,
            default: true,
        },
        step: {
            type: Number,
            default: 1,
            required: false,
        },
    },
    emits: ["update:modelValue", "keyup"],
    setup(__props, { emit }) {
        const props = __props;
        const id = (0, vue_3.ref)((0, randomString_1.default)(12));
        const emitModelValue = (event) => {
            const target = event.target;
            if (target instanceof HTMLInputElement) {
                emit("update:modelValue", props.type === "number"
                    ? Number(target.value).valueOf()
                    : target.value);
            }
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)({
                    'form-input': __props.name !== 'rendszam',
                    'w-full': __props.name === 'search',
                })
            }, [
                (0, vue_2.createElementVNode)("label", { for: id.value }, [
                    (__props.label)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_2, (0, vue_2.toDisplayString)(__props.label), 1))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (__props.icon)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_4, [
                                (0, vue_2.createElementVNode)("i", {
                                    class: (0, vue_2.normalizeClass)(["text-lg text-gray-dark", __props.icon])
                                }, null, 2)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("input", {
                            id: id.value,
                            type: __props.type,
                            name: __props.name,
                            placeholder: __props.placeholder,
                            autofocus: __props.autofocus,
                            required: __props.required,
                            class: (0, vue_2.normalizeClass)(["placeholder-gray-dark outline-none transition-all duration-300 disabled:bg-gray text-input", {
                                    border: __props.border,
                                    'border-gray-dark': __props.border,
                                    'border-opacity-50': __props.border,
                                    'focus:border-blue': __props.border,
                                    'pl-10': __props.icon,
                                    'focus:ring-4': !__props.disableFocusRing,
                                    'focus:ring-blue': !__props.disableFocusRing,
                                    'focus:ring-opacity-50': !__props.disableFocusRing,
                                    //'outline-2 outline-green': valid && showValidity,
                                    'outline-2 outline-red': !__props.valid && __props.showValidity,
                                    'w-full': __props.name === 'search',
                                }]),
                            value: __props.modelValue,
                            disabled: __props.disabled,
                            readonly: __props.readonly,
                            maxlength: __props.maxLength,
                            max: __props.max,
                            pattern: __props.pattern,
                            autocomplete: __props.autocomplete ? 'on' : 'off',
                            step: __props.step,
                            onInput: emitModelValue,
                            onKeyup: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('keyup', $event)))
                        }, null, 42, _hoisted_5)
                    ]),
                    (__props.showValidity && __props.invalidMessage !== '' && !__props.valid)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, (0, vue_2.toDisplayString)(__props.invalidMessage), 1))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 8, _hoisted_1)
            ], 2));
        };
    }
});
